export default function Mobilitate() {
const files = [
  "Adresa mobilitate 02.02.2026.PDF",
  "Adresa mobilitate 22.01.2026.PDF",
  "Adresa mobilitate 23.01.2026.PDF",
  "Adresa mobilitate 27.04.2026.PDF",
  "Decizia Comisia de mobilitate.PDF",
];

  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">

        <div className="space-y-2">
          {files.map((file) => (
            <p key={file}>
              <a
                href={`/documente/mobilitate/${file}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                {file}
              </a>
            </p>
          ))}
        </div>

      </main>
    </div>
  );
}